import Footer from "@/components/Footer";
import Layout from "@/components/Layout";
import React, { useState } from "react";
import BlogCard from "@/components/BlogCard";
import { storefront } from "@/helpers/store";
import { BlogQuery } from "@/helpers/queries";

function Index({ blogs }) {
  console.log(blogs);
  const [selectedTag, setSelectedTag] = useState(null);
  const [filteredArticles, setFilteredArticles] = useState(blogs);
  const [activeLine, setActiveLine] = useState("left-0");

  const handleTagSelection = (tag) => {
    if (tag === selectedTag) {
      setSelectedTag(null);
      setFilteredArticles(blogs);
    } else {
      setSelectedTag(tag);
      const filtered = blogs.filter((article) => article.tags.includes(tag));
      setFilteredArticles(filtered);
    }
  };

  if (!blogs) return <p>Oops! Something went wrong!</p>;

  return (
    <>
      <Layout>
        <h2 className="py-14 text-3xl lg:text-4xl text-center text-[#294870]">
          Sloth News - The Latest <br /> Send a Sloth News
        </h2>

        {/* navigation */}
        <div className="flex items-center justify-center h-auto pt-6 w-full">
          <div className="space-y-2 h-auto py-2 w-full lg:w-[80%]">
            <div className="flex items-center justify-around">
              <button
                onClick={() => {
                  setFilteredArticles(blogs);
                  setActiveLine("left-0");
                }}
                className="text-[10px] sm:text-sm lg:text-base"
              >
                All Topics
              </button>
              <button
                onClick={() => {
                  handleTagSelection("our sloths");
                  setActiveLine("left-[16%]");
                }}
                className="text-[10px] sm:text-sm lg:text-base"
              >
                Our Sloths
              </button>
              <button
                onClick={() => {
                  handleTagSelection("send a sloth");
                  setActiveLine("left-[34%]");
                }}
                className="text-[10px] sm:text-sm lg:text-base"
              >
                Send a Sloth
              </button>
              <button
                onClick={() => {
                  handleTagSelection("send facts");
                  setActiveLine("left-[52%]");
                }}
                className="text-[10px] sm:text-sm lg:text-base"
              >
                Sloth Facts
              </button>
              <button
                onClick={() => {
                  handleTagSelection("sloth in a box");
                  setActiveLine("left-[70%]");
                }}
                className="text-[10px] sm:text-sm lg:text-base"
              >
                Sloth in a Box
              </button>
              <button
                onClick={() => {
                  handleTagSelection("sloths");
                  setActiveLine("left-[85%]");
                }}
                className="text-[10px] sm:text-sm lg:text-base"
              >
                Sloths
              </button>
            </div>
            <div className="relative h-[3px] w-full bg-[#D9DADB]">
              <div
                className={`absolute ${activeLine} top-0 bg-[#294870] h-[3px] w-[15%]`}
              ></div>
            </div>
          </div>
        </div>
        {/* navigation */}

        {/* products list */}
        <div className=" space-y-6 lg:space-y-0 lg:py-24 py-8 w-[100%] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 place-content-center place-items-center">
          {filteredArticles.length > 0 ? (
            filteredArticles.map((article, key) => (
              <>
                <BlogCard
                  key={key}
                  heading={article.title}
                  date={article.publishedAt}
                  img={article.image.originalSrc}
                  link={`/blog/${article.handle}`}
                />
              </>
            ))
          ) : (
            <div className="w-full  flex items-center justify-center">
              <h2 className="ml-14 text-center text-red-600 font-semibold">
                Sorry no Blogs available for this tag
              </h2>
            </div>
          )}
        </div>
      </Layout>

      <Footer />
    </>
  );
}

export default Index;

export async function getStaticProps() {
  try {
    const { data } = await storefront(BlogQuery);

    const blogs = data.blogByHandle.articles.edges.map((edge) => edge.node);

    return {
      props: {
        blogs,
      },
      revalidate: 60, // Set the revalidation time in seconds
    };
  } catch (error) {
    console.error(error);
    return {
      notFound: true,
    };
  }
}
